(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dart-rate-calculator"] && !Shopify.designMode) return;
  try {
    
$(function() {

$( "#total_number" ).on('keyup keypress', function(e) {
  compute();
});

$( "#hours_worked" ).on('keyup keypress', function(e) {
  compute();
});


 
function compute(){
  let total_number = parseFloat($('#total_number').val());
  total_number = total_number > 0 ? total_number : 1;
  let hours_worked = parseFloat($('#hours_worked').val());
  hours_worked = hours_worked ? hours_worked : 28400;
  let incident_rate = 0;

  console.log(total_number+" x "+hours_worked);

  incident_rate = ( total_number * 200000 )/hours_worked;
  let incident_rate_round_off = incident_rate.toFixed(2);

  $('#incident_rate').val(incident_rate_round_off);
  $('#incident_rate_result').text(incident_rate_round_off);
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lost-time-case-rate-calculator"] && !Shopify.designMode) return;
  try {
    
$(function() {

$( "#total_number" ).on('keyup keypress', function(e) {
  compute();
});

$( "#hours_worked" ).on('keyup keypress', function(e) {
  compute();
});


 
function compute(){
  let total_number = parseFloat($('#total_number').val());
  total_number = total_number > 0 ? total_number : 1;
  let hours_worked = parseFloat($('#hours_worked').val());
  hours_worked = hours_worked ? hours_worked : 28400;
  let incident_rate = 0;

  console.log(total_number+" x "+hours_worked);

  incident_rate = ( total_number * 200000 )/hours_worked;
  let incident_rate_round_off = incident_rate.toFixed(2);

  $('#incident_rate').val(incident_rate_round_off);
  $('#incident_rate_result').text(incident_rate_round_off);
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osha-incident-rate-calculator"] && !Shopify.designMode) return;
  try {
    
$(function() {

$( "#total_number" ).on('keyup keypress', function(e) {
  compute();
});

$( "#hours_worked" ).on('keyup keypress', function(e) {
  compute();
});


 
function compute(){
  let total_number = parseFloat($('#total_number').val());
  total_number = total_number > 0 ? total_number : 2;
  let hours_worked = parseFloat($('#hours_worked').val());
  hours_worked = hours_worked ? hours_worked : 28400;
  let incident_rate = 0;

  console.log(total_number+" x "+hours_worked);

  incident_rate = ( total_number * 200000 )/hours_worked;
  let incident_rate_round_off = incident_rate.toFixed(2);

  $('#incident_rate').val(incident_rate_round_off);
  $('#incident_rate_result').text(incident_rate_round_off);
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcr-and-dart-rate-calculator"] && !Shopify.designMode) return;
  try {
    
$(function() {

$( "#tcr_total_number" ).on('keyup keypress', function(e) {
  compute_tcr();
});

$( "#tcr_hours_worked" ).on('keyup keypress', function(e) {
  compute_tcr();
});

$( "#dart_total_number" ).on('keyup keypress', function(e) {
  compute_dart();
});

$( "#dart_hours_worked" ).on('keyup keypress', function(e) {
  compute_dart();
});

function compute_tcr(){
  let total_number = parseFloat($('#tcr_total_number').val());
  total_number = total_number > 0 ? total_number : 1;
  let hours_worked = parseFloat($('#tcr_hours_worked').val());
  hours_worked = hours_worked ? hours_worked : 28400;
  let incident_rate = 0;

  console.log(total_number+" x "+hours_worked);

  incident_rate = ( total_number * 200000 )/hours_worked;
  let incident_rate_round_off = incident_rate.toFixed(2);

  $('#tcr_incident_rate').val(incident_rate_round_off);
  $('#tcr_incident_rate_result').text(incident_rate_round_off);
}

function compute_dart(){
  let total_number = parseFloat($('#dart_total_number').val());
  total_number = total_number > 0 ? total_number : 1;
  let hours_worked = parseFloat($('#dart_hours_worked').val());
  hours_worked = hours_worked ? hours_worked : 28400;
  let incident_rate = 0;

  console.log(total_number+" x "+hours_worked);

  incident_rate = ( total_number * 200000 )/hours_worked;
  let incident_rate_round_off = incident_rate.toFixed(2);

  $('#dart_incident_rate').val(incident_rate_round_off);
  $('#dart_incident_rate_result').text(incident_rate_round_off);

}

});

  } catch(e) { console.error(e); }
})();
})();
